const CONTACT_API_URL = 'https://api.myprivatechemist.com/api/booking/mail/contact';

/*
 * Posts a contact form to the site's real mail endpoint. Field is called
 * "note" on the API side; every page's form state calls it "message", so
 * the mapping happens here rather than renaming anything per-page.
 */
export async function submitContactForm({ name, email, message }) {
  const response = await fetch(CONTACT_API_URL, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ name, email, note: message }),
  });

  if (!response.ok) {
    throw new Error(`Contact form submission failed with status ${response.status}`);
  }

  return response.json();
}
